import React from 'react';

import { token } from '@atlaskit/tokens';
import ChartBarIcon from '@atlaskit/icon/core/chart-bar';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

export const GraphBarIcon = ({ isSelected }: { isSelected: boolean }) => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	return (
		<ChartBarIcon
			spacing="spacious"
			color={isSelected ? token('color.icon.selected', '#0c66e4') : token('color.icon', '#42526E')}
			{...ssrPlaceholderIdProp}
			label=""
			LEGACY_fallbackIcon={() => (
				<svg
					width="25"
					height="25"
					viewBox="0 0 25 25"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					data-vc="graph-bar-icon"
					{...ssrPlaceholderIdProp}
				>
					<path
						d="M19.0234 18.2999C19.5757 18.2999 20.0234 18.7476 20.0234 19.2999C20.0234 19.8127 19.6374 20.2354 19.1401 20.2931L19.0234 20.2999H5.02344C4.47115 20.2999 4.02344 19.8522 4.02344 19.2999C4.02344 18.787 4.40948 18.3644 4.90682 18.3066L5.02344 18.2999H19.0234ZM12.5234 8.30157C13.0363 8.30157 13.4589 8.68761 13.5167 9.18495L13.5234 9.30157V15.3C13.5234 15.8128 13.1374 16.2355 12.6401 16.2932L12.5234 16.3H11.5234C11.0106 16.3 10.5879 15.9139 10.5302 15.4166L10.5234 15.3V9.30157C10.5234 8.78874 10.9095 8.36607 11.4068 8.3083L11.5234 8.30157H12.5234ZM6.02344 12.2999H7.02344C7.53627 12.2999 7.95894 12.6859 8.01671 13.1832L8.02344 13.2999V15.2999C8.02344 15.8127 7.6374 16.2354 7.14006 16.2931L7.02344 16.2999H6.02344C5.5106 16.2999 5.08793 15.9138 5.03017 15.4165L5.02344 15.2999V13.2999L5.03123 13.1744C5.08819 12.7193 5.45104 12.3592 5.9075 12.3065L6.02344 12.2999ZM18.0234 4.29987C18.5363 4.29987 18.9589 4.68591 19.0167 5.18324L19.0234 5.29987V15.2959C19.0234 15.8087 18.6374 16.2314 18.1401 16.2891L18.0234 16.2959H17.0245C16.5116 16.2959 16.089 15.9098 16.0312 15.4125L16.0245 15.2959V5.29987C16.0245 4.78703 16.4105 4.36436 16.9079 4.30659L17.0245 4.29987H18.0234Z"
						fill={
							isSelected ? token('color.icon.selected', '#0c66e4') : token('color.icon', '#42526E')
						}
					/>
				</svg>
			)}
		/>
	);
};
